<template>
  <a
    class="text-tile pos-rel d-flex text-center"
    :href=this.url
  >
    <div class="tile-icon">
      <v-img
        :src="fields.iconUrl"
        height="50"
        contain
        position="center"
      />
    </div>
    <ctf-rich-text
      class="tile-content d-flex align-center text-center"
      :document="fields.body"
    />
    <hidden-btn v-if="fields.button" :btn-id="fields.button.sys.id" ref="btn" />
  </a>
</template>

<script>
import HiddenBtn from '@/components/snippets/hidden-btn'

export default {
  components: {
    HiddenBtn
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      url: undefined
    }
  },
  mounted () {
    // I have no clue when the routes are actually set, but it happends right after component mount? Idk this is the only thing I
    // could find that worked consistently. Sorry...
    setTimeout(this.setUrl, 1000)
  },
  methods: {
    setUrl () {
      const btnRef = this.$refs.btn
      if (btnRef.btnFields?.externalLink) {
        this.url = btnRef.btnFields.externalLink
      } else {
        this.url = btnRef.internalRoute
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.text-tile {
  border: 3px solid $primary;
  border-radius: 10px;
  transition: background 0.3s;
  cursor: pointer;
  vertical-align: middle;
  min-height: 168px;

  .tile-icon {
    width: 75px;
    height: 75px;
    border-radius: 100%;
    background: $white;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  i {
    font-size: 48px;
    color: $secondary;
  }
  .tile-content {
    padding: 2em;
    margin-top: 10px;
    min-width: 100%;
    ::v-deep * {
      min-width: 100% !important;
    }
  }

  &:hover {
    background: $primary;
    .tile-content {
      color: $white;
      ::v-deep * {
        color: $white;
      }
    }
  }

  &:focus {
    background: $primary;
    .tile-content {
      color: $white;
      ::v-deep * {
        color: $white;
      }
    }
  }
}
</style>
